import axios from 'axios'
import { Message } from 'element-ui';
import Vue from 'vue';
import { Toast } from 'vant';
// import 'element-ui/lib/theme-chalk/index.css'

// import {findToken} from '@/api/login'
import store from '@/store'
import { getToken, getConsumerCondition,removeB } from '@/utils/cookies'
import secret from './secret'

const defauleTimeOut = 1000 * 10
const axiosService = axios.create({
  timeout: defauleTimeOut
})
axiosService.defaults.baseURL = '/api'
axiosService.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// axiosService.defaults.headers.post['token'] = xtokenheaders

// http request 拦截器
axiosService.interceptors.request.use(
    

  config => {
    let xtoken = getToken()
    config.ifShowErrorToast = config.hasOwnProperty('ifShowErrorToast') ? config.ifShowErrorToast : true
    xtoken = (xtoken === 'undefined' || xtoken == null) ? '' : xtoken
    // console.log(xtoken)
    // console.log(config)
    if (xtoken !== '') {
      function time(time = +new Date()) {
        var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
        return date.toJSON().substr(0, 19).replace('T', ' ');
      }
      let yToken = {"appCode":"bdks","plat":"pc","time":time(+new Date()),"userToken":xtoken}
      let accessToken =  secret.encrypt(JSON.stringify(yToken),xtoken.slice(0,16)) ;
      config.headers['token'] = xtoken
      config.headers['accessToken'] = accessToken
    }
    xtoken = (xtoken === 'undefined') ? '' : xtoken
    if (config.method === 'post') {
      config.params = {
        // token: xtoken,
        ...config.params
      }
    } else if (config.method === 'get') {
      config.params = {
        // token: xtoken,
        ...config.params
      }
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// respone拦截器
axiosService.interceptors.response.use(
  response => {
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    const loginToken = getConsumerCondition()
    const resData = response.data
    const errorInfo = resData.errorInfo
    const otherData = resData.otherData
    // console.log("sso_errorInfo",errorInfo);
    
    if(errorInfo === 'IllegalArgument'){
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            // Toast(otherData)
            if (response.config.ifShowErrorToast) {
                Toast({ message: otherData, duration: '1000'})
            }
        }else{
            if (response.config.ifShowErrorToast) {
                Vue.prototype.$message.error(otherData)
                // console.log('response.config',Message, response.config.ifShowErrorToast)
            }
        }
        
        return Promise.reject(otherData)
    }
    if (errorInfo === 'tokenInvalid') {
      store.dispatch('FedLogOut').then(res => {
        window.location.reload()
      }).catch(() => {})
    } 
    else if (errorInfo === 'notLogin') {
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        let targetUrl = process.env.SSO_WEB_URL + '/mobileLogin'
        let redirectUrl = secret.encryptionText(window.location.href)
        let targetFullUrl = targetUrl + '?redirectUrl='+redirectUrl
        window.location.href = targetFullUrl
      } else {
        let targetUrl = process.env.SSO_WEB_URL + '/login'
        let redirectUrl = secret.encryptionText(window.location.href)
        let targetFullUrl = targetUrl + '?redirectUrl='+redirectUrl
        window.location.href = targetFullUrl
      }
      // console.log(isLogin, loginToken)
    }  
    else if (errorInfo === 'notAuthor') {
      sessionStorage.setItem('SET_USERINFO','')
      sessionStorage.setItem('SET_ISLOGIN', false)
      let newURL = window.location.href
      let indexStart = newURL.lastIndexOf('/')
      let indexEnd = newURL.indexOf('?') > -1 ? newURL.indexOf('?') : newURL.length
      newURL = newURL.slice(indexStart,indexEnd)
      console.log('newURLaaaaaaaaaaa',newURL)
      //非登录页面 移除token 重新获取
      //因为登录页面还需要再次触发登录点击事件  需要在登录页做移除token 重新获取的处理
      if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        if(newURL != '/mobileLogin'){
          removeB()
          store.dispatch('findToken').then(res => {
            console.log(res.data)
            if(res.data.errorInfo == 'success'){
              location.reload()
            }
          })
        }
      }else{
        if(newURL != '/login'){
          removeB()
          store.dispatch('findToken').then(res => {
            console.log(res.data)
            if(res.data.errorInfo == 'success'){
              location.reload()
            }
          })
        }
      }
      // if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      //   window.location.href= process.env.SSO_WEB_URL+'/mobileLogin';
      // } else {
      //   window.location.href= process.env.SSO_WEB_URL+'/login';
      // }
      
    } else {

    }
    return response
  },
  error => { // 默认除了2XX之外的都是错误的，就会走这里
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (store.state.gameId) {
            /* store.commit('DELETE_TOKEN'  )
            router.replace({ // 跳转到登录页面
              path: '/login?gameId=' + store.state.gameId,
              query: {redirect: router.currentRoute.fullPath, gameId: store.state.gameId} // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }) */
          } else {
            // store.commit('USER_LOGOUT')
          }
      }
    }
    return Promise.reject(error.response)
  }
)

export default axiosService



// WEBPACK FOOTER //
// ./src/utils/request.js